/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Newspage_TitleInputs */

const en_fw_newspage_title = /** @type {(inputs: Fw_Newspage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding news`)
};

const zh_fw_newspage_title = /** @type {(inputs: Fw_Newspage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁新闻`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding news" |
*
* @param {Fw_Newspage_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_newspage_title = /** @type {((inputs?: Fw_Newspage_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Newspage_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_newspage_title(inputs)
	return zh_fw_newspage_title(inputs)
});
export { fw_newspage_title as "fw.newspage.title" }